import { CSV_EXPORT_TYPE, DownloadCsvPagesAndRowsModalValues } from './types';

export const getDownloadCSVRangeRows = (values: DownloadCsvPagesAndRowsModalValues) => ({
  firstRow:
    values.exportType === CSV_EXPORT_TYPE.PAGES
      ? !values.firstPage
        ? 1
        : +values.firstPage * values.limit - values.limit + 1
      : +values.firstRow,
  lastRow: values.exportType === CSV_EXPORT_TYPE.PAGES ? +values.lastPage * values.limit : +values.lastRow
});
